import { useTranslation } from 'react-i18next';

import TOOL_LABEL_KEYS from '../constants/toolLabels';
import isAiChatToolName from '../utils/isAiChatToolName';

/**
 * The name of a tool as the reader sees it.
 *
 * A tool the FE knows is named in the reader's language; any other tool by the name the model
 * called; a call that never named its tool by a stand-in.
 */
const useAiChatToolLabel = (name: string): string => {
  const { t } = useTranslation();

  if (!name) {
    return t('aiChat.toolUnnamed');
  }

  return isAiChatToolName(name) ? t(TOOL_LABEL_KEYS[name]) : name;
};

export default useAiChatToolLabel;
